var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6251 27.1771C44.0664 23.4026 43.3503 19.5832 41.5718 16.225C39.7934 12.8667 37.0364 10.1281 33.6664 8.37201C30.2963 6.61596 26.4722 5.92538 22.7008 6.39176C18.9294 6.85815 15.3887 8.45949 12.548 10.9836C9.70719 13.5077 7.70044 16.8354 6.79362 20.5257C5.88681 24.2161 6.12273 28.0949 7.47013 31.6481C8.81753 35.2014 11.2128 38.2613 14.3385 40.4225C17.4643 42.5837 21.1729 43.7441 24.9731 43.75M7.50012 18.75H42.5001M7.50012 31.25H27.0835M23.9585 6.25C20.4487 11.8742 18.588 18.3706 18.588 25C18.588 31.6294 20.4487 38.1258 23.9585 43.75M26.0418 6.25C30.0401 12.6539 31.8862 20.1683 31.3106 27.6958M33.3335 45.8333L43.7502 35.4167M43.7502 35.4167V44.7917M43.7502 35.4167H34.3752",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntShip);
export default __webpack_public_path__ + "static/media/int-ship.b64e63fde9c804926f5f0d5499b6c8aa.svg";
export { ForwardRef as ReactComponent };